import React, { useState, useEffect } from "react";
import "./styles.css";

const TextFadeAnimation = ({
  texts = [],
  interval = 3000,
  activeIndex = 0,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(null);
  const [triggerFirst, setTriggerFirst] = useState(true);

  useEffect(() => {
    if (texts.length === 0) {
      return;
    }
    if (triggerFirst) {
      return setTriggerFirst(false);
    }
    setPreviousIndex(currentIndex);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
  }, [activeIndex, texts, interval]);

  return (
    <div className="text-animation-container">
      {texts.map((text, index) => {
        let className = "animated-text";

        if (index === currentIndex) {
          className += " active";
        } else if (index === previousIndex) {
          className += " fade-out";
        }
        return (
          <div
            key={index}
            className={className}
            data-testid={`AP_txt${index + 1}`}
          >
            {text}
          </div>
        );
      })}
    </div>
  );
};

export default TextFadeAnimation;
